
import Vue from 'vue'
import Router from 'vue-router'

// Page Website
//// import Home from './views/Home'
const Home = () => import(/* webpackChunkName: "Home" */ '../views/Home/HomeV2')
// Landing Page
const Channel = () => import(/* webpackChunkName: "Channel" */ '../views/Channel')
// New Discovery Category Page
const CategoryPage = () => import(/* webpackChunkName: "CategoryDiscover" */ '../views/Discovery/Category')
// Campaign Overview
const CampaignOverview = () => import(/* webpackChunkName: "CampaignOverview" */ '../views/CampaignOverview')

// We should import store in bottom of components, because route using component and we need use store for auth
import store from '@/store'

Vue.use(Router)

const Init = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/channel/:name',
        name: 'channel',
        component: Channel
    },
    {
        path: '/category/:name',
        name: 'category',
        component: CategoryPage,
        meta: { isStaffV34: true }
    },
    {
        path: '/campaign/:id/overview',
        name: 'campaignoverview',
        component: CampaignOverview,
        props: true,
        meta: { isStaff: true },
    },
]

export default Init;
